export interface ITriggeredFunction {
    (): void;
    reset(): void;
}

const empty = Number.NEGATIVE_INFINITY;

export const triggerOnCount = (
    fn: () => void,
    triggerCount: number,
    triggerWindow: number,
): ITriggeredFunction => {
    let current: number = 0;
    let previous: number = empty;

    const reset = (value: number = 0) => {
        current = value;
        previous = empty;
    };

    const triggeredFn = () => {
        const now = Date.now();

        if (previous === empty || now - previous <= triggerWindow) {
            current += 1;
            previous = now;
            if (current >= triggerCount) {
                fn();
                reset();
            }
        } else {
            reset(1);
        }
    };

    triggeredFn.reset = reset;

    return triggeredFn;
};
